import React from "react";

const Item = ({index,title,body}) => {
    return (
        <>
            <div className="card z-depth-0 bordered reveal" style={{ transitionDelay: (index * 60) + 'ms' }}>
                <div className="card-header" id="heading1">
                    <h5 className="mb-0">
                        <button className="btn btn-link collapsed" 
                        type="button" 
                        data-toggle="collapse" 
                        data-target={"#collapse"+index} 
                        aria-expanded="false" 
                        aria-controls={"#collapse"+index} 
                        dangerouslySetInnerHTML={{ __html: title }}>
                        </button>
                    </h5>
                </div>
                <div id={"collapse"+index} className="collapse" aria-labelledby="heading1" data-parent="#accordionExample">
                    <div className="card-body" dangerouslySetInnerHTML={{ __html: body }}></div>
                </div>
            </div>
        </>
    )
};

export default Item;